<template>
  <div id="secured" ref="start">
    <div id="leftNav" class="sidenav">
      <router-link to="/pos" id="pos">POS</router-link>
    </div>
    <div id="rightNav" class="sidenav2">
      <router-link to="/" id="unsecured">UNSECURED</router-link>
    </div>
    <NavBar mainPage="true" />
    <section class="fullpage" id="secured-head" ref="securedstart">
      <Header
        id="header"
        :title="header.title"
        :info="header.infos"
        :additionalInfo="header.additionalInfo"
        :mainPage="mainPage"
      />
    </section>
    <!-- <section class="features fullpage mid" id="features">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="features-head">Secured Product Features</div>
      </div>
      <div class="services-mid-section">
        <ProductServices class="product-services" :Services="Services" />
      </div>
    </section> -->
    <!-- <section id="secured-steps" class="secured-steps fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="secured-steps-head">Easy steps for SME Loan</div>
      </div>
      <div class="step-mid-section">
        <stepsCarousel class="step-carousel" :steps="loanSteps" />
      </div>
    </section> -->
    <!-- <section id="secured-docs" class="secured-docs fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="documents-head">
          <p>Documents Required</p>
        </div>
      </div>
      <div class="documents-mid-section">
        <Documents class="documents" :documents="documents" ref="productService" />
      </div>
    </section> -->
    <!-- <section id="secured-calc" class="fullpage flexible mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="flexible-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="flexible-head">
          <p>Flexible EDI</p>
        </div>
      </div>
      <div class="flexible-mid-section">
        <FlexibleEDI id="flexibleedi" class="flexible-edi" />
      </div>
    </section> -->

    <!-- <section id="secured-map" class="fullpage map-section mid">
      <div id="testimonial-title" class="map-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="map-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="map-head">
          <p>Loan Applications Processed</p>
        </div>
      </div>
      <div class="map-mid-section">
        <Map
          class="map"
          :heading="headings.map"
          :paragraph="paragraphs.mapParagraph"
          :image="filename.mapImage"
        />
      </div>
    </section> -->
    <section id="secured-recognition" class="secured-recognition mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="recog-head">
          <p>Gallery</p>
        </div>
      </div>
      <div class="recognition-mid-section">
        <Recognition class="recognition" :images="recognitions" />
      </div>
    </section>
    <section id="awards" class="awards mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="awards-head">
          <p>Awards</p>
        </div>
      </div>
      <div class="awards-mid-section">
        <Awards :logos="awardLogos" id="awards-logos" class="awards-main-section" />
      </div>
    </section>
    <section id="video-carousel" class="mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>

        <div class="video-carousel-head">
          <p>Videos</p>
        </div>
      </div>
      <div class="video-carousel-mid-section">
        <Videocarousel :videos="videos" />
      </div>
    </section>
    <section id="media" class="medias mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="media-head">
          <p>Media</p>
        </div>
      </div>
      <div class="media-mid-section">
        <Media class="media-b" :logos="logos" />
      </div>
    </section>
    <section id="partners" class="partners mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="partners-head">
          <p>External Partners</p>
        </div>
      </div>
      <div class="partners-mid-section">
        <Partners :partners="partners" />
      </div>
    </section>
    <section id="secured-testimonial" class="secured-testimonial fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="testi-head">
          <p>Testimonial</p>
        </div>
      </div>
      <div class="testimonials-mid-section">
        <Testimonials class="testi-body" :customerExperiences="customerExperiences" />
      </div>
    </section>
    <section id="secured-app" class="secured-app fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Heading Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="app-head">
          <p>Download ftcash App</p>
        </div>
      </div>
      <div class="download-mid-section">
        <downloadApp
          class="download"
          :heading="headings.download"
          :list="list"
          :paragraph="paragraphs.downloadParagraph"
          :filename="filename"
          :visibility="displayItems.download"
          :sideImage="filename.phoneImage"
        />
      </div>
    </section>
    <section id="foot" class="fullpage" ref="footerSection" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>

<script>
// import ProductServices from "../individual/product-services";
import downloadApp from "../individual/downloadApp";
// import Map from "../individual/map";
// import Documents from "../individual/documents";
// import FlexibleEDI from "../individual/flexible-edi";
//import Featured from "../individual/featured";
// import stepsCarousel from "../individual/steps-carousel";
import Testimonials from "../individual/testimonials/testimonials";
import Recognition from "../new-media-awards/recognition";
import Awards from "../new-media-awards/awards";
//import Videocarousel from "../new-media-awards/video-carousel";
const Videocarousel = () => import('../new-media-awards/video-carousel');
import Media from "../new-media-awards/media";
import Partners from "../new-media-awards/partners";

export default {
  name: "Secured",
  components: {
    // ProductServices,
    downloadApp,
    // Map,
    // Documents,
    // FlexibleEDI,
    //Featured,
    // stepsCarousel,
    Testimonials,
    Recognition,
    Awards,
    Videocarousel,
    Media,
    Partners,
  },

  data() {
    return {
      inMove: false,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      mainPage: true,
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.25, // [0.25, 0.75] if you want a 25% offset!
      },
      headings: {
        features: "Secured Loan Product Features",
        download: "Download the ftcash App",
        map: "Over 100,000 loan applications processed",
        fifth: "External Partners",
      },
      filename: {
        google: "googleplay.png",
        apple: "appstore.png",
        phoneImage: "mobile.png",
        mapImage: "mapImage.png",
      },
      displayItems: {
        Map: false,
        download: true,
      },
      paragraphs: {
        mapParagraph:
          "ftcash is India's one of the fastest growing financial technology venture. Recognized by Forbes, we aim to empower micro-merchants and small businesses through financial inclusion using digital payments and loans.",
        downloadParagraph:
          "Get Collateral free business loan to build the business of your dreams",
      },
      list: {
        line1: "Apply for Secured business loan with just a few clicks",
        line2:
          "No wallet transactions as the Money goes directly into your bank account",
        line3: "Keep a track of invoices and all other transactions",
      },
      header: {
        title: "Get instant secured business loans upto ₹50 lakhs",
        infos:
          "Avail loans with hassle-free documentation, easy collateral options and flexible EDIs",
        additionalInfo: [
          "Loan disbursement in 7 days",
          "Flexible loan tenures for easy repayment",
        ],
      },
      Services: [
        {
          image: "money.png",
          infos: "Loan Upto ₹ 50 Lakhs Available",
          additional: "Borrow higher loan amounts easily",
        },
        {
          image: "card.png",
          infos: "Convenient Repayment Options",
          additional:
            "Say yes to EDIs (Equated Daily Installments) and wave good bye to bulky EMIs",
        },
        {
          image: "mini-mobile.png",
          infos: "Flexible Tenures",
          additional:
            "With up to 60 months of tenure, repaying loan is now easy and convenient",
        },
        {
          image: "mini-home.png",
          infos: "Best LTV (Loan To Value Of Mortgage)",
          additional:
            "No high-priced collaterals needed. Low-value mortgage will get you high value loans",
        },
      ],
      // documents: [
      //   {
      //     image: "Tik-mark-red.png",
      //     icon1: "aadhar_card.png",
      //     document1: "Aadhar Card",
      //     icon2: "pan_card.png",
      //     document2: "PAN Card",
      //   },
      //   {
      //     image: "Tik-mark-red.png",
      //     icon1: "business_photos.png",
      //     document1: "Business Pictures",
      //     icon2: "business_license.png",
      //     document2: "Business License",
      //   },
      //   {
      //     image: "Tik-mark-red.png",
      //     icon1: "bank_statement.png",
      //     document1: "Bank Statements",
      //     icon2: "property_docs.png",
      //     document2: "Property Documents",
      //   },
      // ],
      loanSteps: [
        {
          heading: "Easy steps to getting a secured business loan",
          stepno: "Step 1",
          info: "Check Secured Business Loan Eligibility and Collateral Requirements",
          className: "loanStep1",
          bgImage: "stepsbg1.png",
        },
        {
          heading: "Easy steps to getting a secured business loan",
          stepno: "Step 2",
          info: "Apply with KYC documents and collateral security proof",
          className: "loanStep2",
          bgImage: "stepsbg2.png",
        },
        {
          heading: "Easy steps to getting a secured business loan",
          stepno: "Step 3",
          info: "Verification by the ftcash team",
          className: "loanStep3",
          bgImage: "stepsbg3.png",
        },
        {
          heading: "Easy steps to getting a secured business loan",
          stepno: "Step 4",
          info: "Loan Disbursed!",
          className: "loanStep4",
          bgImage: "stepsbg4.png",
        },
      ],
      logos: [
        {
          logo: "wall_street_logo.png",
          description:
            "Some Good Tech News: Entrepreneurs Leverage Tech for Economic Inclusion",
          visit_url:
            "https://blogs.wsj.com/cio/2018/11/23/some-good-tech-news-entrepreneurs-leverage-tech-for-economic-inclusion/",
        },
        {
          logo: "Techcrunch_logo.png",
          description:
            "ftcash helps Indian businesses accept cashless payments and loans them money",
          visit_url: "https://techcrunch.com/2017/12/04/ftcash/",
        },
        {
          logo: "ndtv_real_deal.png",
          description: "Meet The Real Deal Contestant: Vaibhav Lodha",
          visit_url:
            "https://sites.ndtv.com/therealdeal/video-detail/meet-the-real-deal-contestant-vaibhav-lodha-410065/",
        },
        {
          logo: "times_of_india.png",
          description:
            "ftcash gets Rs 1 crore in pre-series A funding from IvyCap",
          visit_url:
            "http://timesofindia.indiatimes.com/tech/tech-news/FTCash-gets-Rs-1-crore-in-pre-series-A-funding-from-IvyCamp/articleshow/51240457.cms",
        },
        {
          logo: "Forbes_logo.png",
          description: "Fintech firms are a blessing for small entrepreneurs",
          visit_url:
            "https://www.forbesindia.com/article/work-in-progress/hold-on-my-wallets-in-my-phone-fintech-firms-are-a-blessing-for-small-entrepreneurs/43765/0",
        },
        {
          logo: "cnbc-logo.jpg",
          description:
            "Startups raising funds live at Young Turks TiE The Knot",
          visit_url: "https://youtu.be/7QbAd-kH4Pk?t=458",
        },
        {
          logo: "kellogg_logo.png",
          description: "Stripe: Helping Money Move on the Internet",
          visit_url:
            "https://drive.google.com/file/d/1e5zQ_6Lk0dl8sd6cG8tbpHRfk97nATPV/view?usp=sharing",
        },
        {
          logo: "Verve_logo.png",
          description:
            "Vaibhav Lodha talks about India’s thriving Fintech scene",
          visit_url: "https://www.vervemagazine.in/tag/ftcash",
        },
        {
          logo: "economic_times.png",
          description: "ftcash raises Rs 50 crore in Series A",
          visit_url:
            "https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/ftcash-raises-rs-50-crore-in-series-a/articleshow/69155180.cms",
        },
        {
          logo: "hindu.png",
          description: "4 start-ups make it to PayPal incubation programme",
          visit_url:
            "https://www.thehindubusinessline.com/info-tech/4-startups-make-it-to-paypal-incubation-programme/article7838474.ece",
        },
        {
          logo: "crunchbase.png",
          description: "Crunchbase - Top Hot Tech Companies Globally for 2019",
          visit_url:
            "https://about.crunchbase.com/blog/50-hottest-tech-companies-2019/",
        },
        {
          logo: "business_line.png",
          description:
            "Fintech lender ftcash raises Rs 50 crore in Series A funding-round",
          visit_url:
            "https://www.thehindubusinessline.com/companies/fintech-lender-ftcash-raises-rs-50-crore-in-series-a-funding-round/article27012710.ece",
        },
        {
          logo: "business_world.png",
          description: "Ftcash: No Cash, Please",
          visit_url:
            "http://www.businessworld.in/article/Ftcash-No-Cash-Please/25-10-2016-107356/",
        },
        {
          logo: "inc_42.png",
          description:
            "Micro-Lending Startup Ftcash Raises $7.23 Mn Series A Funding",
          visit_url:
            "https://inc42.com/buzz/micro-lending-ftcash-series-a-funding/",
        },
        {
          logo: "et_rise.png",
          description: "ftcash raises Rs 50 crore in Series A",
          visit_url:
            "https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/ftcash-raises-rs-50-crore-in-series-a/articleshow/69155180.cms",
        },
        {
          logo: "bw_disrupt.png",
          description:
            "ftcash Raises Funding at Pitch@RB, Signs MoU with IvyCap Ventures",
          visit_url:
            "http://bwdisrupt.businessworld.in/article/ftcash-Raises-Funding-at-Pitch-RB-Signs-MoU-with-IvyCap-Ventures/11-03-2017-114252/",
        },
        {
          logo: "midday.png",
          description: "Easy breezy Will-Kat impress young innovators",
          visit_url:
            "https://www.mid-day.com/articles/mumbai-easy-breezy-will-kat-impress-young-innovators/17126168",
        },
        {
          logo: "business_standard.png",
          description: "ftcash raises Rs 1 cr in pre-Series A round",
          visit_url:
            "https://www.business-standard.com/article/companies/ftcash-raises-rs-1-cr-in-pre-series-a-round-116030300595_1.html",
        },
        {
          logo: "nikkei.png",
          description: "In India, technology helps the unbankable to bank",
          visit_url:
            "https://asia.nikkei.com/Business/Trends/In-India-technology-helps-the-unbankable-to-bank?page=2",
        },
        {
          logo: "free_press.png",
          description: "Bootstrapping or angel investment?",
          visit_url:
            "https://www.freepressjournal.in/business/bootstrapping-or-angel-investment",
        },
        {
          logo: "live_mint.png",
          description: "No change? No problem",
          visit_url:
            "https://www.livemint.com/Companies/6ugLSlJJaaLlMHwdMcazzL/No-change-No-problem.html",
        },
        {
          logo: "et_tech.png",
          description: "Ftcash raises funds from 500 Startups",
          visit_url:
            "http://tech.economictimes.indiatimes.com/news/startups/ftcash-raises-funds-from-500-startups/59010090",
        },
        {
          logo: "vccircle.png",
          description: "Fin-tech startup Ftcash raises Series A funding",
          visit_url:
            "https://www.vccircle.com/us-non-profit-accion-dutch-bank-fmo-lead-funding-in-fin-tech-startup-ftcash/",
        },
        {
          logo: "your_story.png",
          description:
            "Mumbai-based fintech startup ftcash raises Rs 50 Cr from Accion, FMO, and IvyCap Ventures",
          visit_url:
            "https://yourstory.com/2019/05/mumbai-fintech-startup-ftcash-funding-fmo",
        },
        {
          logo: "accion.png",
          description: "ftcash Raises Approx. $7.2M in Series A Funding",
          visit_url:
            "https://www.accion.org/ftcash-raises-approx-7-2m-in-series-a-funding",
        },
        {
          logo: "owler.png",
          description:
            "ftcash's Competitors, Revenue, Number of Employees, Funding and Acquisition",
          visit_url: "https://www.owler.com/company/ftcash",
        },
        {
          logo: "tech_circle.png",
          description:
            "Fintech startup ftcash raises $7.22 mn in Series A round led by Dutch lender FMO",
          visit_url:
            "https://www.techcircle.in/2019/05/03/fintech-startup-ftcash-raises-7-22-mn-in-series-a-round-led-by-dutch-lender-fmo",
        },
        {
          logo: "medianama.png",
          description:
            "Payments company Ftcash raises pre-series A round: report",
          visit_url:
            "https://www.medianama.com/2017/06/223-ftcash-funding-500-startups/",
        },
        {
          logo: "angel_list.png",
          description: "Payments Anytime Anywhere",
          visit_url: "https://angel.co/company/ftcash",
        },
        {
          logo: "innovation_hub.png",
          description:
            "Ten startups graduate from Facebook and T-Hub’s India Innovation Accelerator program",
          visit_url:
            "https://www.thenewsminute.com/article/ten-startups-graduate-facebook-and-t-hub-s-india-innovation-accelerator-program-112978",
        },
        {
          logo: "financial_express.png",
          description:
            "Facebook, T-Hub pick these 10 AI startups for accelerator programme",
          visit_url:
            "https://www.financialexpress.com/industry/sme/facebook-t-hub-picks-these-10-ai-startups-for-accelerator-programme-offers-technology-mentoring-other-support/1647387/",
        },
      ],
      customerExperiences: [
        {
          customerVideo: "bhavna_testimonial.mp4",
          heading:
            "Introducing our customer, Mrs Bhavna Chahal, Founder of ‘Just 4 Kids’.",
          subheading: "Founder of ‘Just 4 Kids’",
          thumbnail: "bhavna_video_thumbnail.jpg",
          description:
            "Mrs. Bhavna has been a ftcash customer since the inception of the company. Recently, she required a working capital loan for her business and she reached out to our customer care centre to inquire about a loan. To her pleasant surprise, the loan was disbursed within a week with minimal documentation. What she found most fascinating was that she continued her business, as usual, using the ftcash PoS system and the loan started to get repaid without her having to think about it. Such stories continue to inspire us to support women entrepreneurs in their journies. We appreciate the kind words by her and look forward to a long and fruitful association with 'Just 4 Kids'.",
        },
        // {
        //   customerVideo: "swapnil_testimonial.mp4",
        //   heading: "Mr. Swapnil Pawar, Proprietor of Welcome Mobile Store",
        //   subheading: "",
        //   thumbnail: "swapnil_video_thumbnail.jpg",
        //   description:
        //     "A Delighted ftcash Customer Mr. Swapnil has been a ftcash payments customers for last 1 year. When he required a working capital loan for peak season in his business, he reached out to ftcash. Within a week of his documentation, the money was credited to Mr. Swapnil's company account. Mr. Swapnil recognizes the convenience of repayment from his PoS machine on a daily basis and he doesn't have to track his EMIs anymore. He has been an active evangelist for ftcash and has even taken a top-up loan after 6 months. ftcash is proud to be a part of the success story of Mr. Swpanil and Welcome Mobile Store.",
        // },
         {
          customerVideo: "dilpreet_testimonial.mp4",
          heading:
            "Meet our customer, Mrs. Dilpreet Narula, Proprietor of Nazrana Needlcrafts Store",
          subheading: "",
          thumbnail: "dilpreet_video_thumbnail.jpg",
          description:
            "Mrs. Dilpreet aspired to expand her business but her loan application was rejected by several banks. After she approached ftcash for a loan for business expansion, ftcash disbursed her Rs.100,000 loan within a week of documentation.She has been able to scale her business to get hire additional staff. ftcash is always there to help small merchants scale their businesses and provide capital for their working capital needs.",
        },
        {
          customerVideo: "nayan_testimonial.mp4",
          heading:
            "Meet our customer, Mr. Nayan Babariya,Proprietor of Ravinath Hardware Store",
          subheading: "",
          thumbnail: "nayan_video_thumbnail.jpg",
          description:
            "Recently, Mr. Nayan required a working capital loan for his business and he reached out to our customer care centre to inquire about a loan. ftcash disbursed the loan within a week with minimal documentation. He used that money to buy a new hardware products and hired additional staff. ftcash is always there to help small merchants scale their businesses and provide capital for their working capital needs.",
        },
      ],
      awardLogos: [
        {
          logo: "uk_trade.png",
          description: "UK Trade and Investment- Great Tech Rocketships",
          visit_url:
            "https://www.gov.uk/government/world-location-news/six-indian-companies-emerge-as-winners-of-great-tech-rocketships-2016",
        },
        {
          logo: "mit.png",
          description:
            "MIT awards $250,000 for “Most Innovative Future of Work in the World”",
          visit_url:
            "https://www.forbes.com/sites/gradsoflife/2018/11/15/mit-awards-1-million-to-most-innovative-future-of-work-organizations-in-the-world/#3ba7c1e7668a",
        },
        {
          logo: "uniliver.png",
          description: "Unilever Young Entrepreneur Awards Recognition",
          visit_url:
            "https://www.unilever.com/about/inspiringaction/unilever-young-entrepreneurs-awards/awards-2018/meet-our-2018-young-entrepreneurs-awards-highly-commended-semi-finalists/?fbclid=IwAR2pSpkZoyQfrc2Ma-rziZM71Z2t6pSJ16mNPeP3rQGkapaJwVv8CZ87-lU",
        },
        {
          logo: "ntt_data_innovation.png",
          description: "NTT Data Open Innovation 7.0 – Global Winner",
          visit_url: "https://oi.nttdata.com/en/contest/7th/about/",
        },
        {
          logo: "nasscom_emerge.png",
          description: "NASSCOM Emerge 50",
          visit_url: "https://www.nasscom.in/emerge50/Emerge-50-2016.Pdf",
        },
        {
          logo: "nasscom_awards_2019.png",
          description: "NASSCOM India Fintech Awards",
          visit_url: "http://10000startups.com/IndiaFintechDay2019/",
        },
        {
          logo: "ibm_smart_camp.png",
          description: "IBM Fintech Smart Camp",
          visit_url: "https://inc42.com/buzz/winners-ibm-smartcamp/",
        },
        {
          logo: "red_herring_asia.png",
          description: "Red Herring Asia 50",
          visit_url:
            "http://www.redherring.com/events/red-herring-asia/2016-finalists/",
        },
        {
          logo: "kpmg_100.png",
          description: "KPMG Hot 100 Startups",
          visit_url:
            "https://www.industrialautomationindia.in/newsitm/5950/MIT-Awards-$250,000-to-ftcash-for-Most-Innovative-Future-of-Work-in-the-World/news",
        },
        {
          logo: "singapore.png",
          description: "Awarded by Singapore Fintech Festival",
          visit_url: "https://fintechnews.sg/tag/ftcash/",
        },
        {
          logo: "sankalp_global_summit.png",
          description: "Winner at 10th Global Summit",
          visit_url:
            "https://www.intellecap.com/announcements/10th-sankalp-global-summit-2018-concludes-successfully-with-debate-and-discussions-on-serving-the-underserved-3-billion-people/",
        },
        {
          logo: "pitch_rb.png",
          description:
            "ftcash participates in the 3rd ‘Festival of Innovation’ with a Pitch@RB at Rashtrapati Bhavan",
          visit_url:
            "https://www.channelinfoline.com/article/ftcash-participates-in-the-3rd-festival-of-innovation-with-a-pitchrb-at-rashtrapati-bhavan/",
        },
        {
          logo: "iim_ahmedabad.png",
          description: "IIM Ahmedabad CIIE Fellowship",
          visit_url: "https://ciie.co/",
        },
        {
          logo: "mBillionth.png",
          description: "mBillionth Awards",
          visit_url: "http://mbillionth.in/business-commerce-winners-2016/",
        },
        {
          logo: "the_fintech_20.png",
          description: "The Fintech20: India",
          visit_url: "https://issuu.com/fintechcity/docs/ft50_16_spreads_lo/20",
        },
        {
          logo: "nasscom_retech.png",
          description: "NASSCOM & Retailers Association of India",
          visit_url: "https://retechcon.com/retechstartupawards2016/",
        },
        {
          logo: "village_capital.png",
          description: "FinTech India",
          visit_url:
            "https://www.profitbooks.net/profitbooks-named-in-top-3-fintech-companies-in-india/",
        },
      ],
      videos: [
        {
          video_thumbnail: "vaibhav_sir_thumbnail1.jpg",
          video_url: "https://www.youtube.com/embed/exhUIN7Hofs",
          video_description:{
            line1:'NDTV The Real Deal - Vaibhav Lodha, Co founder, ftcash. ',
            line2:'Vaibhav is the Co founder of fTCash, a PayPal backed startup in the financial technology space serving the underserved micro-merchants in India'

          } 
        },
        {
          video_thumbnail: "sanjeev_sir_thumbnail.jpg",
          video_url: "https://www.youtube.com/embed/nJEuoKCZLZY",
          video_description: {
            line1:'OCBCxSFF2017 Day 3: Hackcelerator Finalist – ',
            line2:'ftcash was the finalist on day three of the Singapore FinTech Festival 2017'
          }
        },
        {
          video_thumbnail: "deepak_sir_thumbnail.jpg",
          video_url: "https://www.youtube.com/embed/eIwfG_QKrz0",
          video_description:{
            line1:'Fintech AbuDhabi, Innovation Challenge - Part One (featuring ftcash)',
            line2:'ftcash providing a demo of solutions to FinTech Problem sets.'
          
          }
        },
        {
          video_thumbnail: "vaibhav_sir_thumbnail2.jpg",
          video_url: "https://www.youtube.com/embed/9qoCR4SUEvM",
          video_description: {
            line1:'ftcash - 2017 Global FinTech Hackcelerator Demo',
            line2:"ftcash's 5-minute pitch at Demo Day, held on 16 November 2017, Singapore FinTech Festival."
          }
        },
      ],
      partners: [
        {
          partner_name: "Stanford",
          partner_image: "stanford.png",
          partner_url: "https://www.stanford.edu/",
        },
        {
          partner_name: "Paypal",
          partner_image: "paypal_logo.png",
          partner_url: "https://www.paypal.com/",
        },
        {
          partner_name: "Mastercard",
          partner_image: "mastercard.png",
          partner_url: "https://www.mastercard.co.in/en-in.html",
        },
        {
          partner_name: "Facebook",
          partner_image: "facebook.png",
          partner_url: "https://www.facebook.com/",
        },
        {
          partner_name: "ISB",
          partner_image: "isb.png",
          partner_url: "https://www.isb.edu/en.html",
        },
        {
          partner_name: "Acumen",
          partner_image: "acumen.png",
          partner_url: "https://acumen.org/",
        },
        {
          partner_name: "Bain&Co",
          partner_image: "bain.png",
          partner_url: "https://www.bain.com/",
        },
        {
          partner_name: "MIT",
          partner_image: "massachusetts.png",
          partner_url: "https://www.mit.edu/",
        },
      ],
      recognitions: [
        {
          image: "award1.jpg",
          description:
            "Our CEO, Mr. Sanjeev Chandak meeting Honorable Queen Maxima of Netherlands",
          visit_url: "#",
        },
        {
          image: "award2.jpg",
          description:
            "Winner of MIT Inclusive Innovation Challenge",
          visit_url: "#",
        },
        {
          image: "award3.jpg",
          description:
            "Invited by Honorable President of India to Rashtrapati Bhavan to celebrate festival of innovation day",
          visit_url: "#",
        },
        {
          image: "award5.jpg",
          description:
            "Winner of Prestigious Award at NTT Data Open Innovation – Global Grand Finale in Tokyo",
          visit_url: "#",
        },
        {
          image: "award7.jpg",
          description:
            "Winner for ReTech Startup Awards 2016 hosted by the Retailers Association of India",
          visit_url: "#",
        },
      ],
    };
  },
  beforeCreate(){
  // if(this.$router.currentRoute.path=='/secured'){
  //       this.$router.push("pos")
  //     }
  },
  created() {
    //console.log(this.$router.currentRoute.path);
    
  },

  mounted() {

    this.$refs.securedstart.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  },
  methods: {
    reload() {
      window.scrollTo(0, 0);
    },
  },
  metaInfo() {
    return{
    meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Avail secured business loans for your business enterprise with hassle-free processing. Check your business loan eligibility & apply now!"
        }
      ],
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/secured' },
    ],
    }
  },
};
</script>

<style scoped>
/* Tag CSS */

/* Class CSS */
.waypoint {
  height: 10px;
  background-color: red;
}
.waypoint {
  height: 10px;
  background-color: red;
}

/* ID CSS */
#secured-head {
  height: 100vh;
  width: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.33), rgba(0, 0, 0, 0.78)),
    url("../../assets/background/secured_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
#leftNav a {
  position: fixed;
  z-index: 1;
  left: 0px;
  width: 36px;
  height: 219px;
  font-size: 1rem;
  writing-mode: vertical-rl;
  text-orientation: upright;
  -webkit-text-orientation: upright;
  color: var(--mainWhiteColor);
  border-radius: 0 5px 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  text-decoration: none;
}
#leftNav a:hover {
  box-shadow: 0px 0px 8px rgb(31 61 113);
  /* transition: ease 0.5s;
  background-color: white;
  color: #1f3d73;
  border: 1px solid #1f3d73; */
}
#pos {
  top: 37%;
  background-color: var(--mainBlueColor);
}
#rightNav a {
  position: fixed;
  z-index: 1;
  right: 0px;
  width: 36px;
  height: 219px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  -webkit-text-orientation: upright;
  font-size: 1rem;
  /* transition: ease 0.5s; */
  color: var(--mainWhiteColor);
  border-radius: 5px 0 0 5px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
#rightNav a:hover {
  box-shadow: 0px 0px 8px rgb(31 61 113);
  /* transition: ease 0.5s;
  background-color: white;
  color: #1f3d73;
  border: 1px solid #1f3d73; */
}
#unsecured {
  top: 37%;
  background-color: var(--mainBlueColor);
}
.features,
.secured-docs,
.secured-steps,
.flexible,
.secured-app,
.map-section,
.secured-recognition,
.awards,
.medias,
.partners,
.secured-testimonial {
  position: relative;
}
.features-image-bg {
  width: 92px;
  height: 114px;
  float: right;
}
.map-image-bg {
  width: 92px;
  height: 114px;
  float: right;
}

/*Heading Text Heads*/
.features-head {
  font-size: 3.3rem;
  position: absolute;
  right: 67px;
  float: right;
  z-index: 2;
  top: 49px;
}
/* Easy Steps */
.secured-steps-head {
  font-size: 3.3rem;
  position: absolute;
  right: 59px;
  float: right;
  z-index: 2;
  top: 47px;
}
/* Documents Required */
.documents-head {
  font-size: 3.3rem;
  position: absolute;
  right: 56px;
  float: right;
  z-index: 2;
  top: 45px;
}
/* Flexible EDI */
.flexible-head {
  font-size: 3.3rem;
  position: absolute;
  right: 80px;
  float: right;
  z-index: 2;
  top: 48px;
}
/* Download App */
.app-head {
  font-size: 3.3rem;
  position: absolute;
  right: 62px;
  float: right;
  z-index: 2;
  top: 44px;
}
/* Map */
.map-head {
  font-size: 3.3rem;
  position: absolute;
  right: 57px;
  float: right;
  z-index: 2;
  top: 48px;
}
/* Gallery */
.recog-head {
  font-size: 3.3rem;
  position: absolute;
  right: 64px;
  float: right;
  z-index: 2;
  top: 44px;
}
/* Awards */
.awards-head {
  font-size: 3.3rem;
  position: absolute;
  right: 64px;
  float: right;
  z-index: 2;
  top: 46px;
}
/* Media */
.media-head {
  font-size: 3.3rem;
  position: absolute;
  right: 61px;
  float: right;
  z-index: 2;
  top: 47px;
}
/* External Partners */
.partners-head {
  font-size: 3.3rem;
  position: absolute;
  right: 68px;
  float: right;
  z-index: 2;
  top: 46px;
}
/* Testimonials */
.testi-head {
  font-size: 3.3rem;
  position: absolute;
  right: 82px;
  float: right;
  z-index: 2;
  top: 51px;
}
/* Video-carousel*/
.video-carousel-head {
  font-size: 3.3rem;
  position: absolute;
  right: 67px;
  float: right;
  z-index: 2;
  top: 46px;
}
.awards-title-section {
  width: 100vw;
  min-height: 114px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  z-index: -2;
}

.map-title-section {
  width: 100vw;
  min-height: 114px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  z-index: -2;
}
/*Mid Sections*/
.flexible-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.documents-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.download-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.services-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.step-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.map-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-image: url("../../assets/background/map-background.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
.recognition-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.awards-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.video-carousel-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-color: #1f3d73;
  background-repeat: no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  width: 100vw;
}
.media-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
.partners-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.testimonials-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}

.flexible-img {
  right: 0;
  z-index: -1;
}
.award-title {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
  float: right;
}
.awards-image-bg {
  width: 160px;
  height: 130px;
  float: right;
}

.awards-img {
  right: 0;
  z-index: -1;
}

.color_white {
  color: white;
}

.video-carousel-image-bg {
  width: 100px;
  height: 114px;
  float: right;
}
#video-carousel {
  position: relative;
}

/* Media Queries */
/* Tablet Views */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  #secured-head {
    align-items: center;
    display: flex !important;
    box-shadow: 0 3000px rgba(0, 0, 0, 0.4) inset;
    background-size: cover;
    background-position: 63% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  .map-section {
    background-position: center center;
    background-size: contain;
  }
  /*
  .product-services,
  .documents {
    margin-top: 60px;
  }*/
  .media-body {
    display: flex;
    align-items: center;
  }
  /* Features */
  .features-image-bg {
    width: 36px;
  }
  .map-image-bg {
    width: 36px;
  }
  .features-head,
  .secured-steps-head,
  .documents-head,
  .flexible-head,
  .app-head,
  .map-head,
  .recog-head,
  .awards-head,
  .media-head,
  .partners-head,
  .testi-head,
  .video-carousel-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  /* Awards & Media */
 /* .awards-main-section {
    margin-top: 7rem;
  } */
  .awards-title-section {
    width: 100vw;
    /* min-height: 50px; */
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
   /* position: absolute; */
    top: 0;
    z-index: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-img {
    position: static;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  #secured-head {
    align-items: center;
    display: flex !important;
    box-shadow: 0 3000px rgba(0, 0, 0, 0.4) inset;
    background-size: cover;
    background-position: 63% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  /* #flexibleedi {
    transform: none;
  } */
  .mid {
    margin-top: 0;
  }
  .map-section {
    background-position: center center;
    background-size: cover;
  }
  /* section:nth-child(odd):nth-last-child(n + 7) {
    }*/
}
/* Mobile Views */
@media (min-width: 481px) and (max-width: 767px) {
  #secured-head {
    height: 100vh;
    align-items: center;
    display: flex !important;
    box-shadow: 0 3000px rgba(0, 0, 0, 0.4) inset;
    background-size: cover;
    background-position: 63% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  /* #flexibleedi {
    transform: none;
  } */
  .mid {
    padding: 2rem 0;
  }
  .map-section {
    background-position: 100% 100%;
    background-size: contain;
  }
  section#awards {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
  }
  section#media {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
    z-index: 2;
  }
  section#secured-steps {
    min-height: 60vh;
    display: flex !important;
  }
  section#video-carousel {
    min-height: 63vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
    /* background-position: 62.5% 100%; */
    background-color: var(--mainBlueColor);
    z-index: 2;
  }

  .product-services,
  .documents {
    margin-top: 50px;
  }

  .recognition,
  .testi-body,
  .flexible-edi {
    margin: 50px 0 0 0;
    position: static;
  }
  .map,
  .media-body {
    margin-top: 60px;
    position: static;
  }
  /* Features */
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .map-image-bg {
    width: 36px;
    height: 68px;
  }
  .features-head,
  .secured-steps-head,
  .documents-head,
  .flexible-head,
  .app-head,
  .map-head,
  .recog-head,
  .awards-head,
  .media-head,
  .partners-head,
  .testi-head,
  .video-carousel-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .step-carousel {
    margin: 45px 0 0 0;
    position: static;
  }
  /* Awards & Media */
  .awards-main-section {
    margin-top: 50px;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
    z-index: initial;
  }
  .map-title-section {
    width: 100vw;
    min-height: 68px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
    z-index: 3;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 0;
  }
  /* Video Carousel*/
  .video-carousel-image-bg {
    width: 36px;
    height: 58px;
  }
  section#secured-testimonial {
    padding-bottom: 0;
  }
  section#features {
      z-index: 2;
  }
  .services-mid-section {
    background-color: transparent;
  }
  .step-carousel {
    margin: 56px 0 0 0;
    position: static;
  }
  section#secured-docs {
      z-index: 2;
  }
  .documents-mid-section {
    background-color: transparent;
  }
  .recognition-mid-section {
    background-color: transparent;
  }
  section#secured-recognition {
      z-index: 2;
  }
  section#secured-calc {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .video-carousel-mid-section {
    background-color: transparent;
    background-image: none;
  }
  .video-carousel {
    margin-top: 70px;
  }
  .media-mid-section {
    margin-top: 45px;
  }

  .partners {
    padding-top: 29px;
  }
  .flexible-edi {
    margin-top: 65px;
  }
  .testi-body {
    margin: 65px 0 0 0;
    position: static;
  }
  .download {
    padding-top: 66px;
    position: static;
  }
  section#secured-map {
    background-image: url("../../assets/background/map-background.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    -o-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    z-index: 2;
  }
  .map-mid-section {
    background-color: transparent;
    background-image: none;
  }
}
@media (max-width: 480px) {
  #secured-head {
    align-items: center;
    display: flex !important;
    box-shadow: 0 3000px rgba(0, 0, 0, 0.4) inset;
    background-size: cover;
    background-position: 63% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  /* #flexibleedi {
    transform: none;
  } */
  .mid {
    padding: 2rem 0;
  }
  .map-section {
    background-position: 100% 100%;
    background-size: contain;
  }
  /*section:nth-child(odd):nth-last-child(n + 7) {
    }*/
  section#media {
    min-height: 75vh;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
    /*background-image: url("../../assets/background/media_bg.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover; */
    z-index: 2;
  }
  section#awards {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
  }
  section#video-carousel {
    min-height: 70vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
    /* background-position: 62.5% 100%; */
    background-color: var(--mainBlueColor);
    z-index: 2;
  }
  section#secured-testimonial {
    padding-bottom: 0;
  }
  section#secured-steps {
    min-height: 60vh;
    display: flex !important;
  }
  .mid {
    padding: 2rem 0;
  }

  .product-services,
  .media-body,
  .documents {
    margin-top: 45px;
  }
  .recognition {
    margin: 45px 0 0 0;
    position: static;
  }
  .download {
    padding-top: 66px;
    position: static;
  }

  .map {
    margin: 100px 0 0 0;
    position: static;
  }
  /* Features */
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .map-image-bg {
    width: 36px;
    height: 98px;
  }
  .features-head,
  .secured-steps-head,
  .documents-head,
  .flexible-head,
  .app-head,
  .map-head,
  .recog-head,
  .awards-head,
  .media-head,
  .partners-head,
  .testi-head,
  .video-carousel-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .step-carousel {
    margin: 45px 0 0 0;
    position: static;
  }
  /* Awards & Media */
  .awards-main-section {
    margin-top: 45px;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
    z-index: initial;
  }
  .map-title-section {
    width: 100vw;
    min-height: 98px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
    z-index: 3;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 0;
  }
  /* Video Carousel*/
  .video-carousel-image-bg {
    width: 36px;
    height: 58px;
  }
  section#features {
      z-index: 2;
  }
  .services-mid-section {
    background-color: transparent;
  }
  section#secured-docs {
      z-index: 2;
  }
  .documents-mid-section {
    background-color: transparent;
  }
  section#secured-map {
    background-image: url("../../assets/background/map-background.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    -o-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    z-index: 2;
  }
  .map-mid-section {
    background-color: transparent;
    background-image: none;
  }
  .recognition-mid-section {
    background-color: transparent;
  }
  section#secured-recognition {
      z-index: 2;
  }
  .video-carousel-mid-section {
    background-color: transparent;
    background-image: none;
  }
  .video-carousel {
    margin-top: 70px;
  }
  .media-mid-section {
    margin-top: 45px;
  }
  .partners {
    padding-top: 25px;
  }
  .flexible-edi {
    margin-top: 65px;
  }
  .testi-body {
    margin: 65px 0 0 0;
    position: static;
  }
}
</style>
